import { useState } from "react";
import axios from "axios";
import { Amendment } from "../types/Amendments";

const useSelectedAmendmentsExport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const exportSelectedAmendments = async (
    amendmentIds: string[]
  ): Promise<Amendment[]> => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        `https://oparl-textprovider-production.up.railway.app/exporter/amendments`,
        //`http://localhost:1080/exporter/amendments`,
        {
          amendmentsIds: amendmentIds,
        }
      );

      setError(null);
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        setError(`Error: ${err.response.statusText}`);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred");
      }
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { exportSelectedAmendments, loading, error };
};

export default useSelectedAmendmentsExport;
